export default {
  baseUrlMicrofrontend: "https://app.dev-auth.surepoint.cloud",
  ssoApiBaseUrl: "https://apiv2.dev-auth.surepoint.cloud",
  addInDomainUrl: "https://addin.dev-auth.surepoint.cloud",
};

export const env_name = "dev";
